import Block from '../block'

export default class ProductInfo extends Block {
	static title = 'product-info'

	init() {
		this.productPayload = {
			productId: this.element.querySelector('input[name="product_id"]').value,
			colorId: null,
			sizeId: null,
		}

		if (this.element.querySelector('input[name="color_id"]:checked')) {
			this.productPayload.colorId = this.element.querySelector(
				'input[name="color_id"]:checked'
			).value
		}

		// textual indicators of selected size and color
		this.colorNameElement = this.getElement('color-name')
		this.sizeNameElement = this.getElement('size-name')

		this.formElement = this.getElement('form')
		if (this.formElement) {
			this.formElement.addEventListener('submit', e => this.submitForm(e))
		}

		this.errorElement = this.element.querySelector('.message--error')

		this.eventEmitter.on('color:change', obj => this.colorChange(obj))
		this.eventEmitter.on('size:change', obj => this.sizeChange(obj))
	}

	colorChange(obj) {
		this.productPayload.sizeId = null
		this.productPayload.colorId = obj.colorId
		if (this.colorNameElement && obj.colorName) {
			this.colorNameElement.textContent = obj.colorName
		}
	}

	sizeChange(obj) {
		this.productPayload.sizeId = obj.sizeId
		if (this.sizeNameElement && obj.sizeName) {
			this.sizeNameElement.textContent = obj.sizeName
		}

		this.hideErrorMessage()
	}

	submitForm(e) {
		// b2b add to carts should just be a redirect
		if (this.hasModifier('b2b')) {
			return
		}

		e.preventDefault()

		if (this.element.dataset.optionless) {
			this.addToShoppingcart()
			return
		}

		if (!this.productPayload.sizeId || !this.productPayload.colorId) {
			this.showErrorMessage()
			return
		}

		if (!this.productPayload.productId) {
			this.showErrorMessage()
			return
		}
		this.addToShoppingcart()
	}

	showErrorMessage() {
		if (!this.isValidBlock(this.errorElement)) {
			return
		}

		this.errorElement.ref.open()
	}

	hideErrorMessage() {
		if (!this.isValidBlock(this.errorElement)) {
			return
		}

		this.errorElement.ref.close()
	}

	addToShoppingcart() {
		let payload = new FormData()
		payload.append('ajax', true)
		payload.append('product_id', this.productPayload.productId)
		payload.append('color_id', this.productPayload.colorId)
		payload.append('size_id', this.productPayload.sizeId)
		payload.append('add', true)

		fetch('/shoppingcart', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then(response => response.json())
			.then(json => this.handleAddResponse(json))
			.catch(error => this.handleError(error))
	}

	handleAddResponse(json) {
		if (json.error) {
			return
		}

		this.eventEmitter.emit('product:add', json)
	}
}